import React, { useState, useRef, useEffect } from 'react';
import { useLanguage, languages } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

export const LanguageSelector = ({ variant = 'light' }) => {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find(l => l.code === language) || languages[0];

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const isDark = variant === 'dark';

  return (
    <div className="relative" ref={ref} data-testid="language-selector">
      <button onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-colors ${
          isDark
            ? 'text-[#999] hover:text-white hover:bg-[#222]'
            : 'text-[#6E5E52] hover:text-[#2D241D] hover:bg-[#F3EDE5]'
        }`}
        data-testid="language-selector-btn">
        <Globe className="w-3.5 h-3.5" />
        <span>{current.flag} {current.code.toUpperCase()}</span>
      </button>
      {open && (
        <div className={`absolute right-0 top-full mt-1 rounded-xl border shadow-lg z-50 min-w-[140px] overflow-hidden ${
          isDark ? 'bg-[#1A1A1A] border-[#333]' : 'bg-white border-[#E5DCD3]'
        }`}>
          {languages.map(l => (
            <button key={l.code}
              onClick={() => { setLanguage(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-xs transition-colors ${
                language === l.code
                  ? 'bg-[#D4A853]/10 text-[#D4A853]'
                  : isDark ? 'text-[#CCC] hover:bg-[#222]' : 'text-[#2D241D] hover:bg-[#F3EDE5]'
              }`}
              data-testid={`lang-${l.code}`}>
              <span>{l.flag}</span>
              <span className="font-medium">{l.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
